import { ssnSchema } from 'shared/components/vxl/input/schemas/ssn.schema';
import { z } from 'zod';

export const SSNVerificationSchema = z.object({
  ssnText: ssnSchema,
});
